/* ============================================================
   SV Eichede — Theme-Interaktion (Design 3.0)
   Framework-frei. Countdown wurde bewusst entfernt.
   ============================================================ */
(function () {
  "use strict";

  /* ---- Legacy-Hover (ältere Sections mit data-hs) ---- */
  function wireHover(attr) {
    document.querySelectorAll("[" + attr + "]").forEach(function (el) {
      var base = el.getAttribute("style") || "";
      var hov = el.getAttribute(attr);
      el.addEventListener("mouseenter", function () { el.setAttribute("style", base + ";" + hov); });
      el.addEventListener("mouseleave", function () { el.setAttribute("style", base); });
      el.addEventListener("focus", function () { el.setAttribute("style", base + ";" + hov); });
      el.addEventListener("blur", function () { el.setAttribute("style", base); });
    });
  }

  /* ---- Bild-Slider (Stadion-Geschichte) ---- */
  function wireSliders() {
    document.querySelectorAll("[data-slider]").forEach(function (root) {
      var slides = root.querySelectorAll("[data-slide]");
      var dots = root.querySelectorAll("[data-slide-dot]");
      var cap = root.querySelector("[data-slide-cap]");
      var i = 0, n = slides.length, timer;
      var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      function show(k) {
        i = (k + n) % n;
        slides.forEach(function (el, x) { el.style.opacity = x === i ? "1" : "0"; el.style.zIndex = x === i ? "2" : "1"; });
        dots.forEach(function (el, x) { el.style.background = x === i ? "#fff" : "rgba(255,255,255,.5)"; });
        if (cap) cap.textContent = slides[i].getAttribute("data-cap") || "";
      }
      root.querySelectorAll("[data-slide-prev]").forEach(function (b) { b.addEventListener("click", function () { show(i - 1); reset(); }); });
      root.querySelectorAll("[data-slide-next]").forEach(function (b) { b.addEventListener("click", function () { show(i + 1); reset(); }); });
      dots.forEach(function (b, x) { b.addEventListener("click", function () { show(x); reset(); }); });
      function reset() { clearInterval(timer); if (!still) timer = setInterval(function () { show(i + 1); }, 6000); }
      show(0); reset();
    });
  }

  /* ---- Warenkorb ---- */
  function refreshCartCount() {
    if (!window.fetch) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; });
        toggleCartBar(c.item_count);
      })
      .catch(function () {});
  }

  /* Kasse-Leiste: erscheint, sobald etwas im Warenkorb liegt */
  var cartBar = null;
  function toggleCartBar(count) {
    if (!count) { if (cartBar) cartBar.remove(); cartBar = null; return; }
    if (!cartBar) {
      cartBar = document.createElement("div");
      cartBar.className = "sve-cartbar";
      cartBar.setAttribute("role", "status");
      cartBar.style.cssText = "position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:150;display:flex;align-items:center;gap:14px;background:var(--ink);color:#fff;border-radius:10px;padding:12px 14px 12px 20px;box-shadow:0 24px 50px -20px rgba(0,0,0,.55);font-size:1.4rem;max-width:calc(100vw - 24px);animation:sve-modal-in .25s ease both;";
      cartBar.innerHTML =
        '<span style="font-weight:600;white-space:nowrap;"><span data-cartbar-count>' + count + '</span> im Warenkorb</span>' +
        '<a href="/cart" style="color:rgba(255,255,255,.8);text-decoration:underline;text-underline-offset:3px;white-space:nowrap;">Ansehen</a>' +
        '<a href="/checkout" class="sve-btn sve-btn--solid" style="padding:12px 18px;white-space:nowrap;">Zur Kasse &rarr;</a>';
      document.body.appendChild(cartBar);
    } else {
      var c = cartBar.querySelector("[data-cartbar-count]");
      if (c) c.textContent = count;
    }
  }

  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (res) { refreshCartCount(); return res; });
  }

  function wireAddToCart() {
    document.querySelectorAll("[data-cart-add][data-variant-id]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        addToCart(btn.getAttribute("data-variant-id"), parseInt(btn.getAttribute("data-quantity") || "1", 10));
      });
    });
  }

  /* ---- Ticket-Shop 3.0: Spiel wählen -> Kartenart -> Menge ---- */
  function euro(cents) {
    return (cents / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }
  function wireTicketShop() {
    document.querySelectorAll("[data-ticket-shop]").forEach(function (shop) {
      var matches = shop.querySelectorAll("[data-match]");
      var tiersWrap = shop.querySelector("[data-tiers]");
      var qtyVal = shop.querySelector("[data-qty-val]");
      var sumEl = shop.querySelector("[data-sum]");
      var addBtn = shop.querySelector("[data-cart-add-ticket]");
      var msg = shop.querySelector("[data-ticket-msg]");
      if (!matches.length || !addBtn) return;
      var state = { variants: [], tier: null, buyable: false, qty: 1 };

      function update() { if (sumEl) sumEl.textContent = state.tier ? euro(state.tier.price * state.qty) : "–"; }

      function highlightTier() {
        tiersWrap.querySelectorAll("button").forEach(function (b) {
          var on = b.__variant === state.tier;
          b.style.borderColor = on ? "var(--red)" : "var(--line)";
          b.style.background = on ? "var(--red)" : "#fff";
          b.style.color = on ? "#fff" : "var(--body-text)";
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
      }
      function selectTier(v) { state.tier = v; highlightTier(); update(); }
      function renderTiers() {
        tiersWrap.innerHTML = "";
        if (!state.variants.length) {
          var note = document.createElement("div");
          note.style.cssText = "grid-column:1/-1;font-size:1.3rem;color:var(--muted);border:1.5px dashed var(--line);border-radius:6px;padding:14px 16px;line-height:1.5;";
          note.textContent = "Preise folgen – Tickets gibt es an der Tageskasse.";
          tiersWrap.appendChild(note);
          return;
        }
        state.variants.forEach(function (v) {
          var b = document.createElement("button");
          b.type = "button"; b.__variant = v;
          b.innerHTML = '<span style="font-weight:700;">' + v.title + '</span><span style="font-family:ui-monospace,Menlo,monospace;">' + euro(v.price) + "</span>";
          b.style.cssText = "display:flex;justify-content:space-between;align-items:center;gap:12px;width:100%;padding:14px 16px;border-radius:8px;font-size:1.5rem;cursor:pointer;transition:all .15s ease;border:1.5px solid var(--line);background:#fff;color:var(--body-text);";
          b.addEventListener("click", function () { selectTier(v); });
          tiersWrap.appendChild(b);
        });
        highlightTier();
      }
      function selectMatch(btn) {
        matches.forEach(function (t) {
          t.style.borderColor = "var(--line)";
          t.style.boxShadow = "none";
          t.setAttribute("aria-pressed", "false");
        });
        btn.style.borderColor = "var(--red)";
        btn.style.boxShadow = "0 0 0 3px rgba(var(--red-rgb),.15)";
        btn.setAttribute("aria-pressed", "true");
        var vs = [];
        try { vs = JSON.parse(btn.getAttribute("data-variants") || "[]"); } catch (e) {}
        state.variants = vs;
        state.buyable = btn.getAttribute("data-buyable") === "true";
        if (msg) msg.textContent = "";
        renderTiers();
        state.tier = null;
        if (vs.length) selectTier(vs[0]); else update();
      }

      var dec = shop.querySelector("[data-qty-dec]"), inc = shop.querySelector("[data-qty-inc]");
      if (dec) dec.addEventListener("click", function () { state.qty = Math.max(1, state.qty - 1); qtyVal.textContent = state.qty; update(); });
      if (inc) inc.addEventListener("click", function () { state.qty = Math.min(20, state.qty + 1); qtyVal.textContent = state.qty; update(); });
      matches.forEach(function (btn) { btn.addEventListener("click", function () { selectMatch(btn); }); });
      selectMatch(matches[0]);

      addBtn.addEventListener("click", function () {
        if (!state.tier) { if (msg) msg.textContent = "Bitte erst eine Preisstufe wählen."; return; }
        if (!state.buyable || !state.tier.id) {
          if (msg) msg.textContent = "Online-Kauf für diese Karte folgt in Kürze – Tickets gibt es an der Tageskasse.";
          return;
        }
        if (msg) msg.textContent = "…";
        addToCart(state.tier.id, state.qty)
          .then(function () { if (msg) msg.textContent = "Liegt im Warenkorb ✓"; })
          .catch(function () { if (msg) msg.textContent = "Das hat nicht geklappt – bitte noch einmal versuchen."; });
      });
    });
  }

  /* ---- Akkordeon (in [data-acc-group] exklusiv: nur eines offen) ---- */
  function wireAccordion() {
    var groups = new Map();
    document.querySelectorAll("[data-acc]").forEach(function (item) {
      var btn = item.querySelector("[data-acc-btn]");
      var panel = item.querySelector("[data-acc-panel]");
      var icon = item.querySelector("[data-acc-icon]");
      if (!btn) return;
      var open = item.hasAttribute("data-acc-open");
      var group = item.closest("[data-acc-group]");
      function render() {
        if (panel) panel.style.display = open ? "" : "none";
        if (icon) icon.textContent = open ? "▴" : "▾";
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        item.style.borderColor = open ? "var(--red)" : "var(--line)";
        item.style.boxShadow = open ? "0 0 0 3px rgba(var(--red-rgb),.10)" : "none";
      }
      item.__accSet = function (v) { open = v; render(); };
      render();
      if (group) {
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(item);
      }
      btn.addEventListener("click", function () {
        open = !open;
        if (open && group) {
          groups.get(group).forEach(function (other) {
            if (other !== item && other.__accSet) other.__accSet(false);
          });
        }
        render();
      });
    });
  }

  /* ---- Mitgliedschaft: Tarif links steuert Formular & Leistungen rechts ---- */
  function wireMembership() {
    document.querySelectorAll("[data-fee]").forEach(function (fee) {
      var root = fee.closest("section") || document;
      var btn = fee.querySelector("[data-acc-btn]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var idx = fee.getAttribute("data-fee");
        var name = fee.getAttribute("data-fee-name") || "";
        var input = root.querySelector("[data-tarif-input]");
        var disp = root.querySelector("[data-tarif-display]");
        if (input) input.value = name;
        if (disp) disp.textContent = name;
        var label = root.querySelector("[data-benefits-for]");
        if (label) label.textContent = "· " + name.split(" · ")[0];
        var lists = root.querySelectorAll("[data-fee-benefits]");
        var hit = false;
        lists.forEach(function (l) {
          var on = l.getAttribute("data-fee-benefits") === idx;
          l.style.display = on ? "flex" : "none";
          if (on) hit = true;
        });
        var def = root.querySelector("[data-benefits-default]");
        if (def) def.style.display = hit ? "none" : "flex";
      });
    });
  }

  /* ---- Team-Explorer (Mannschaften) ---- */
  function wireTeamExplorer() {
    document.querySelectorAll("[data-tx]").forEach(function (root) {
      var btns = root.querySelectorAll("[data-tx-btn]");
      var panels = root.querySelectorAll("[data-tx-panel]");
      function select(i) {
        btns.forEach(function (b, x) {
          var on = x === i;
          b.setAttribute("aria-selected", on ? "true" : "false");
          b.style.background = on ? "var(--red)" : "#fff";
          b.style.color = on ? "#fff" : "var(--ink)";
          b.style.borderColor = on ? "var(--red)" : "var(--line)";
          var lg = b.querySelector("[data-tx-liga]");
          if (lg) lg.style.color = on ? "rgba(255,255,255,.75)" : "var(--muted)";
        });
        panels.forEach(function (p, x) { p.style.display = x === i ? "" : "none"; });
      }
      btns.forEach(function (b, x) { b.addEventListener("click", function () { select(x); }); });
      if (btns.length) select(0);
    });
  }

  /* ---- Modal (Kader) mit ESC + Fokus-Trap ---- */
  function wireModals() {
    var lastFocus = null;
    function close(modal) {
      modal.style.display = "none";
      document.body.style.overflow = "";
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }
    function open(modal) {
      lastFocus = document.activeElement;
      modal.style.display = "";
      document.body.style.overflow = "hidden";
      var f = modal.querySelector("[data-modal-close]");
      if (f) f.focus();
    }
    document.querySelectorAll("[data-modal-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var modal = document.getElementById(btn.getAttribute("data-modal-open"));
        if (modal) open(modal);
      });
    });
    document.querySelectorAll("[data-modal]").forEach(function (modal) {
      modal.style.display = "none";
      modal.addEventListener("click", function (e) { if (e.target === modal) close(modal); });
      modal.querySelectorAll("[data-modal-close]").forEach(function (b) { b.addEventListener("click", function () { close(modal); }); });
      modal.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { close(modal); return; }
        if (e.key !== "Tab") return;
        var els = modal.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
        if (!els.length) return;
        var first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      });
    });
  }








  /* ---- Coach: Vereins-Helfer mit besserem Sprachverständnis ---- */
  function wireEichi() {
    var root = document.querySelector("[data-eichi]");
    if (!root) return;
    var data;
    try { data = JSON.parse(root.querySelector("[data-eichi-wissen]").textContent); } catch (e) { return; }
    var panel = root.querySelector("[data-eichi-panel]");
    var log = root.querySelector("[data-eichi-log]");
    var chips = root.querySelector("[data-eichi-chips]");
    var form = root.querySelector("[data-eichi-form]");
    var input = root.querySelector("[data-eichi-input]");
    var opened = false;

    var STOP = ["der","die","das","und","oder","ich","du","wir","ihr","ist","sind","was","wie","wo","wann","wer","kann","man","mir","mich","ein","eine","einen","für","zum","zur","beim","bei","den","dem","des","es","gibt","hat","habe","mein","meine","auch","noch","mal","bitte","gern","gerne","hallo","moin","hey"];
    function norm(t) {
      return t.toLowerCase()
        .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
        .replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();
    }
    function stem(w) { return w.replace(/(ern|en|er|es|e|n|s)$/, ""); }
    function words(t) {
      return norm(t).split(" ").filter(function (w) { return w.length > 1 && STOP.indexOf(w) === -1; });
    }
    function lev(a, b) {
      if (Math.abs(a.length - b.length) > 2) return 99;
      var m = [];
      for (var i = 0; i <= a.length; i++) { m[i] = [i]; }
      for (var j = 0; j <= b.length; j++) { m[0][j] = j; }
      for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++)
        m[i][j] = Math.min(m[i-1][j] + 1, m[i][j-1] + 1, m[i-1][j-1] + (a[i-1] === b[j-1] ? 0 : 1));
      return m[a.length][b.length];
    }
    function wordScore(qw, kw) {
      if (qw === kw) return 3;
      var qs = stem(qw), ks = stem(kw);
      if (qs === ks) return 2.5;
      if (kw.length > 3 && (qw.indexOf(kw) === 0 || kw.indexOf(qw) === 0)) return 2;
      if (kw.length >= 5 && lev(qs, ks) <= (kw.length >= 8 ? 2 : 1)) return 1.5;
      return 0;
    }
    function score(fact, qWords, qNorm) {
      var total = 0;
      (fact.k || "").split(",").forEach(function (kw) {
        kw = norm(kw.trim());
        if (!kw) return;
        if (kw.indexOf(" ") > -1) { if (qNorm.indexOf(kw) > -1) total += 4; return; }
        var best = 0;
        qWords.forEach(function (qw) { var sc = wordScore(qw, kw); if (sc > best) best = sc; });
        total += best;
      });
      return total;
    }

    function bubble(text, who, link, label) {
      var div = document.createElement("div");
      div.className = "sve-eichi-msg sve-eichi-msg--" + who;
      div.textContent = text;
      if (link) {
        var a = document.createElement("a");
        a.href = link; a.textContent = label || "Mehr dazu";
        a.style.cssText = "display:inline-block;margin-top:8px;color:var(--red);font-weight:700;";
        div.appendChild(document.createElement("br"));
        div.appendChild(a);
      }
      log.appendChild(div);
      log.scrollTop = log.scrollHeight;
      return div;
    }

    function suggest(facts) {
      var div = document.createElement("div");
      div.className = "sve-eichi-msg sve-eichi-msg--bot";
      div.textContent = "Meintest du vielleicht:";
      facts.forEach(function (fact) {
        if (!fact.q) return;
        var b = document.createElement("button");
        b.type = "button"; b.className = "sve-eichi-chip";
        b.style.cssText = "display:block;margin-top:8px;";
        b.textContent = fact.q;
        b.addEventListener("click", function () { ask(fact.q); });
        div.appendChild(b);
      });
      log.appendChild(div);
      log.scrollTop = log.scrollHeight;
    }

    function answer(q) {
      var qNorm = norm(q), qWords = words(q);
      var ranked = (data.facts || []).map(function (fact) {
        return { fact: fact, s: score(fact, qWords, qNorm) };
      }).sort(function (a, b) { return b.s - a.s; });
      setTimeout(function () {
        var best = ranked[0];
        if (best && best.s >= 2) {
          bubble(best.fact.a, "bot", best.fact.url || null, best.fact.label);
          var alt = ranked[1];
          if (alt && alt.s >= 2 && alt.s >= best.s * 0.8 && alt.fact.q) suggest([alt.fact]);
        } else if (best && best.s > 0) {
          suggest(ranked.slice(0, 3).filter(function (r) { return r.s > 0; }).map(function (r) { return r.fact; }));
        } else {
          bubble(data.fallback, "bot", data.contact_url, "Zum Kontakt");
        }
      }, 350);
    }

    function ask(q) {
      if (!q) return;
      bubble(q, "user");
      answer(q);
    }

    function open() {
      panel.hidden = false;
      if (!opened) {
        opened = true;
        bubble(data.greeting, "bot");
        (data.facts || []).slice(0, 4).forEach(function (fact) {
          if (!fact.q) return;
          var c = document.createElement("button");
          c.type = "button"; c.className = "sve-eichi-chip"; c.textContent = fact.q;
          c.addEventListener("click", function () { ask(fact.q); });
          chips.appendChild(c);
        });
      }
      input.focus();
    }
    function close() { panel.hidden = true; }

    root.querySelector("[data-eichi-toggle]").addEventListener("click", function () {
      panel.hidden ? open() : close();
    });
    root.querySelector("[data-eichi-close]").addEventListener("click", close);
    panel.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    document.querySelectorAll("[data-eichi-open]").forEach(function (b) {
      b.addEventListener("click", open);
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = input.value.trim();
      input.value = "";
      ask(q);
    });
  }


  /* ---- Mosaik: Thema-Kacheln ausklappen ---- */
  function wireMosaik() {
    document.querySelectorAll("[data-mos-toggle]").forEach(function (tile) {
      var text = tile.querySelector("[data-mos-text]");
      var hint = tile.querySelector("[data-mos-hint]");
      if (!text) return;
      tile.addEventListener("click", function () {
        var open = tile.getAttribute("aria-expanded") === "true";
        tile.setAttribute("aria-expanded", open ? "false" : "true");
        text.style.maxHeight = open ? "0" : text.scrollHeight + "px";
        if (hint) hint.textContent = open ? "Mehr lesen +" : "Weniger –";
      });
    });
  }

  /* ---- Spiel-Kalender: Pfeile + Tab-Filter ---- */
  function wireCalendar() {
    document.querySelectorAll("[data-cal]").forEach(function (root) {
      var track = root.querySelector("[data-cal-track]");
      if (!track) return;
      var prev = root.querySelector("[data-cal-prev]");
      var next = root.querySelector("[data-cal-next]");
      function step() { var card = track.querySelector("[data-cal-card]"); return card ? card.offsetWidth + 16 : 320; }
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
      var tabs = root.querySelectorAll("[data-cal-tab]");
      var cards = root.querySelectorAll("[data-cal-card]");
      function applyTab(name) {
        tabs.forEach(function (t) { t.setAttribute("aria-pressed", t.getAttribute("data-cal-tab") === name ? "true" : "false"); });
        cards.forEach(function (c) { c.style.display = c.getAttribute("data-tab") === name ? "" : "none"; });
        track.scrollTo({ left: 0 });
      }
      tabs.forEach(function (t) { t.addEventListener("click", function () { applyTab(t.getAttribute("data-cal-tab")); }); });
      if (tabs.length) applyTab(tabs[0].getAttribute("data-cal-tab"));
    });
  }

  /* ---- Wort-Rotator (Leitbild) ---- */
  function wireRotator() {
    document.querySelectorAll("[data-rotate]").forEach(function (root) {
      var words = root.children;
      if (words.length < 2 || reduced) return;
      var i = 0;
      setInterval(function () {
        words[i].style.display = "none";
        i = (i + 1) % words.length;
        var w = words[i];
        w.style.display = "block";
        w.style.animation = "none";
        void w.offsetWidth;
        w.style.animation = "sve-rise .5s cubic-bezier(.2,.7,.2,1) both";
      }, 2600);
    });
  }

  /* ---- Track-Slider (Matchday u. a.) ---- */
  function wireTrackSlider() {
    document.querySelectorAll("[data-tslider]").forEach(function (root) {
      var scope = root.closest("section") || root;
      var track = root.querySelector("[data-ts-track]");
      var slides = track ? track.children : [];
      var dots = root.querySelectorAll("[data-ts-dot]");
      var prev = scope.querySelector("[data-ts-prev]");
      var next = scope.querySelector("[data-ts-next]");
      if (!track || slides.length < 2) return;
      var i = 0, n = slides.length;
      function show(k) {
        i = (k + n) % n;
        track.style.transform = "translateX(-" + (i * 100) + "%)";
        dots.forEach(function (d, x) { d.style.background = x === i ? "var(--red)" : "rgba(255,255,255,.25)"; });
      }
      if (prev) prev.addEventListener("click", function () { show(i - 1); });
      if (next) next.addEventListener("click", function () { show(i + 1); });
      dots.forEach(function (d, x) { d.addEventListener("click", function () { show(x); }); });
      root.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") show(i - 1);
        if (e.key === "ArrowRight") show(i + 1);
      });
      show(0);
    });
  }

  /* ---- Trainingszeiten-Finder ---- */
  function wireTrainingFinder() {
    document.querySelectorAll("[data-tf]").forEach(function (root) {
      var sel = root.querySelector("[data-tf-year]");
      var results = root.querySelector("[data-tf-results]");
      var teams = root.querySelectorAll("[data-tf-team]");
      var empty = root.querySelector("[data-tf-empty]");
      if (!sel || !results) return;
      function matches(spec, year) {
        return spec.split(",").some(function (part) {
          part = part.trim();
          if (!part) return false;
          if (part.indexOf("-") > -1) {
            var r = part.split("-");
            return year >= parseInt(r[0], 10) && year <= parseInt(r[1], 10);
          }
          return parseInt(part, 10) === year;
        });
      }
      sel.addEventListener("change", function () {
        var year = parseInt(sel.value, 10);
        if (!year) { results.style.display = "none"; return; }
        results.style.display = "flex";
        var hits = 0;
        teams.forEach(function (t) {
          var on = matches(t.getAttribute("data-years") || "", year);
          t.style.display = on ? "" : "none";
          if (on) {
            hits++;
            t.style.animation = "none";
            void t.offsetWidth;
            t.style.animation = "sve-rise .5s cubic-bezier(.2,.7,.2,1) both";
            t.style.animationDelay = (hits - 1) * 90 + "ms";
          }
        });
        if (empty) empty.style.display = hits ? "none" : "";
      });
    });
  }

  /* ---- Sponsor-Showcase: Kategorie-Filter ---- */
  function wireSponsorFilter() {
    document.querySelectorAll("[data-sf]").forEach(function (root) {
      var chips = root.querySelectorAll("[data-sf-chip]");
      var cards = root.querySelectorAll("[data-sf-card]");
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          var cat = chip.getAttribute("data-sf-chip");
          chips.forEach(function (c) { c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
          cards.forEach(function (card) {
            var cc = card.getAttribute("data-sf-card");
            var show = cat === "__alle" || cc === cat || cc === "__join";
            card.classList.toggle("is-hide", !show);
          });
        });
      });
    });
  }

  /* ---- Design 3.1: Scroll-Reveals, Count-up, 1947-Parallax ---- */
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function wireReveals() {
    if (reduced || !("IntersectionObserver" in window)) return;
    var els = document.querySelectorAll("main .sve-eyebrow, main .sve-display, main .sve-card");
    var list = [];
    els.forEach(function (el) {
      if (el.closest(".sve-reveal")) return;           // Hero hat eigenen Load-Reveal
      if (el.closest("[data-modal]")) return;          // Modals nicht
      el.classList.add("sve-io");
      list.push(el);
    });
    var io = new IntersectionObserver(function (entries) {
      var i = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.transitionDelay = (i++ % 5) * 70 + "ms";
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.1 });
    list.forEach(function (el) { io.observe(el); });
  }

  function wireCountUp() {
    if (!("IntersectionObserver" in window)) return;
    var els = document.querySelectorAll("[data-count]");
    if (!els.length) return;
    function animate(el) {
      var raw = el.textContent.trim();
      var m = raw.match(/([\d.,]+)/);
      if (!m) return;
      var hasSep = m[1].indexOf(".") > -1 || m[1].indexOf(",") > -1;
      var target = parseInt(m[1].replace(/[.,]/g, ""), 10);
      if (!target || reduced) return;
      var start = null, dur = 1200;
      function fmt(n) { return hasSep ? n.toLocaleString("de-DE") : String(n); }
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = raw.replace(m[1], fmt(Math.round(target * eased)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function wireParallax() {
    if (reduced) return;
    var els = document.querySelectorAll(".sve-1947");
    if (!els.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var offset = (r.top + r.height / 2 - vh / 2) * -0.07;
        el.style.setProperty("--par", offset.toFixed(1) + "px");
      });
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }


  /* ---- Spieltags-Leiste: Auto-Befüllung via Worker (Fallback: manuelle Pflege) ---- */
  function wireMatchdayAuto() {
    var bar = document.querySelector("[data-nb-auto]");
    if (!bar || !window.fetch) return;
    fetch(bar.getAttribute("data-nb-auto"), { mode: "cors" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) return;
        var el;
        if (d.datetime_label && (el = bar.querySelector("[data-nb-date]"))) el.textContent = d.datetime_label;
        if (d.title && (el = bar.querySelector("[data-nb-title]"))) el.textContent = d.title;
      })
      .catch(function () { /* still: manuelle Werte bleiben stehen */ });
  }

  function init() {
    [
      function () { wireHover("data-hs"); wireHover("data-hf"); },
      wireSliders, wireTrackSlider, wireRotator, wireCalendar, wireMosaik, wireAddToCart, wireTicketShop, wireAccordion, wireMembership,
      wireSponsorFilter, wireTrainingFinder, wireTeamExplorer, wireModals,
      wireEichi, wireMatchdayAuto, wireReveals, wireCountUp, wireParallax, refreshCartCount
    ].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error("SVE theme.js:", e); }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
